import React from 'react'
import PropTypes from 'prop-types'
import { StaticQuery, graphql } from 'gatsby'
import classnames from 'classnames'

import ContactForm from '../components/Contact/ContactForm'

import styles from '../styles/sections/Contact.module.css'

const Contact = props => {
  const sectionClassName = classnames(styles.section, 'section')
  const containerClassName = classnames(styles.container, 'container')

  const mapUrl = `https://www.google.com/maps?q=${encodeURIComponent(
    props.site.siteMetadata.address
  )}`
  const phoneUrl = `tel:+55${props.site.siteMetadata.phone.replace(/[^0-9]/g, '')}`
  const mailUrl = `mailto:${props.site.siteMetadata.email}`
  const whatsAppUrl = `https://wa.me/55${props.site.siteMetadata.whatsapp.replace(
    /[^0-9]/g,
    ''
  )}?text=Oi`

  return (
    <section id={props.markdownRemark.frontmatter.id} className={sectionClassName}>
      <div className={containerClassName}>
        <div className={styles.textWrapper}>
          <h2 className={styles.title}>
            {props.markdownRemark.frontmatter.title}
            <small className={styles.subtitle}>{props.markdownRemark.frontmatter.subtitle}</small>
          </h2>

          <ul className={styles.infos}>
            <li className={styles.info}>
              <a
                href={mapUrl}
                className={styles.infoLink}
                target='_blank'
                rel='noopener noreferrer'
              >
                <img className={styles.pin} src='contact/pin.svg' alt='Endereço.' />
                <p className={styles.infoText}>
                  <strong>Endereço</strong>
                  {props.site.siteMetadata.address}
                </p>
              </a>
            </li>

            <li className={styles.info}>
              <a href={phoneUrl} className={styles.infoLink}>
                <img className={styles.phone} src='contact/phone.svg' alt='Telefone.' />
                <p className={styles.infoText}>
                  <strong>Telefone</strong>
                  {props.site.siteMetadata.phone}
                </p>
              </a>
            </li>

            <li className={styles.info}>
              <a href={mailUrl} className={styles.infoLink}>
                <img className={styles.mail} src='contact/mail.svg' alt='E-mail.' />
                <p className={styles.infoText}>
                  <strong>E-mail</strong>
                  {props.site.siteMetadata.email}
                </p>
              </a>
            </li>

            <li className={styles.info}>
              <a href={whatsAppUrl} className={styles.infoLink}>
                <img className={styles.whatsapp} src='contact/whatsapp.svg' alt='Whatsapp.' />
                <p className={styles.infoText}>
                  <strong>Whatsapp</strong>
                  {props.site.siteMetadata.whatsapp}
                </p>
              </a>
            </li>
          </ul>
        </div>

        <div className={styles.formWrapper}>
          <h3 className={styles.formText}>{props.markdownRemark.frontmatter.formText}</h3>
          <ContactForm />
        </div>
      </div>
    </section>
  )
}

Contact.propTypes = {
  markdownRemark: PropTypes.shape({
    frontmatter: PropTypes.shape({
      id: PropTypes.string,
      title: PropTypes.string,
      subtitle: PropTypes.string,
      formText: PropTypes.string
    }),
    html: PropTypes.string
  }),
  site: PropTypes.shape({
    siteMetadata: PropTypes.shape({
      email: PropTypes.string,
      address: PropTypes.string,
      phone: PropTypes.string,
      whatsapp: PropTypes.string
    })
  })
}

const contactQuery = graphql`
  query ContactQuery {
    markdownRemark(frontmatter: { id: { eq: "contact" } }) {
      frontmatter {
        id
        title
        subtitle
        formText
      }
      html
    }
    site {
      siteMetadata {
        email
        address
        phone
        whatsapp
      }
    }
  }
`

export default () => <StaticQuery query={contactQuery} render={data => <Contact {...data} />} />
